jQuery(function() {

    const directoryListingsForm = document.querySelector('.js-directory-listings-form');

    if (!directoryListingsForm) {
        return;
    }

    jQuery('.branch-directory__select, .directory-top__select').on('change', function() {
        jQuery(this).closest('form').submit();
    });

    handleCheckboxesWithMobileMultiselect(directoryListingsForm);
});

/**
 * Handle checkboxes which use a multiselect of the same name on mobile.
 *
 * Any change of a checkbox or multiselect will trigger a form submission. If it's a checkbox that has changed,
 * the multiselect of the same name will be disabled to prevent it from being submitted and vice versa.
 *
 * @param {Element} directoryListingsForm
 */
function handleCheckboxesWithMobileMultiselect(directoryListingsForm) {
    const checkboxesWithMobileMultiselectContainer = directoryListingsForm.querySelectorAll('.js-checkboxes-with-mobile-multiselect');
    checkboxesWithMobileMultiselectContainer.forEach(container => {
        const checkboxFields = container.querySelectorAll('input[type="checkbox"]');
        const $select2 = jQuery(container).find('.js-multiselect-for-checkboxes');
        checkboxFields.forEach(field => {
            field.addEventListener('change', function() {
                // Disable select2 as it's checkboxes that have changed
                $select2.attr('disabled', true);

                directoryListingsForm.submit();
            });
        });

        const select2 = $select2.select2({
            placeholder: jQuery(this).data('placeholder'),
        });

        select2.on('select2:select', function(e) {
            disableFormFields(checkboxFields);
            directoryListingsForm.submit();
        });
        select2.on('select2:unselect', function(e) {
            disableFormFields(checkboxFields);
            directoryListingsForm.submit();
        });

        jQuery(container).find('.select2-selection').on(
            'click',
            '.select2-selection__choice__remove',
            function(e) {
                // prevent opening the select2 dropdown when clicking the remove button as we're reloading the page
                return false;
            }
        );
    });
}

/**
 * Set disabled attribute on form fields.
 *
 * @param {NodeList} fields
 */
function disableFormFields(fields) {
    jQuery(fields).each(function(i, field) {
        jQuery(field).attr('disabled', true);
    });
}